import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';

@Component({
    selector: 'fi-checklist-ai-assistance-prompt-samples-section',
    template: `
        <p class="ai-assistance-prompt-samples-section-heading">{{ heading }}</p>
        <div class="ai-assistance-prompt-sample-buttons-wrapper">
            @for (prompt of prompts; track prompt) {
                <button mat-button class="ai-assistance-prompt-sample-button" (click)="onPromptClick(prompt)">
                    <span class="button-label">
                        <mat-icon class="far fa-stars" />
                        <span class="button-text">
                            {{ getSampleText(prompt) }}
                            <fi-info-icon
                                tooltipClass="fi-rounded-white-tooltip no-arrow"
                                fiInfoPosition="top"
                                [hideTooltipOnHoverInsideTooltip]="true"
                                [mode]="FiInfoIconMode.WithoutIconAbsolute"
                            >
                                {{ getSampleText(prompt) }}
                            </fi-info-icon>
                        </span>
                    </span>
                </button>
            }
        </div>
    `,
    styleUrl: './checklist-ai-assistance-prompt-samples-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-ai-assistance-prompt-samples-section' },
    standalone: false,
})
export class FiChecklistAiAssistancePromptSamplesSection<T> {
    @Input({ required: true }) prompts: T[] = [];
    @Input({ required: true }) heading: string;
    @Input({ required: true }) itemDisplayValuePropName: string;
    @Input() itemDisplaySummaryPropName: string = 'Summary';
    @Output() promptClick = new EventEmitter<T>();

    protected getSampleText(prompt: T): string {
        return prompt[this.itemDisplaySummaryPropName] ?? prompt[this.itemDisplayValuePropName];
    }

    protected onPromptClick(prompt: T): void {
        this.promptClick.emit(prompt);
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
